import { API_KEY_PREFIX } from "./apiKeyPrefix";

const TOKEN_ALPHABET =
  "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

function base64UrlNoPad(bytes: Uint8Array): string {
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary)
    .replaceAll("+", "-")
    .replaceAll("/", "_")
    .replaceAll("=", "");
}

export async function hashApiKey(key: string): Promise<string> {
  const bytes = new TextEncoder().encode(key);
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return base64UrlNoPad(new Uint8Array(digest));
}

// Single bias-free token generator shared by API keys and SCIM tokens:
// rejection sampling keeps the alphabet distribution uniform.
export function generateToken(prefix: string): string {
  const maxValid =
    Math.floor(256 / TOKEN_ALPHABET.length) * TOKEN_ALPHABET.length;
  const bytes = new Uint8Array(64);
  let suffix = "";

  while (suffix.length < 32) {
    crypto.getRandomValues(bytes);
    for (const byte of bytes) {
      if (byte >= maxValid) continue;
      suffix += TOKEN_ALPHABET.charAt(byte % TOKEN_ALPHABET.length);
      if (suffix.length === 32) break;
    }
  }

  return `${prefix}${suffix}`;
}

export function generateApiKey(): string {
  return generateToken(API_KEY_PREFIX);
}
